"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDigestItemDto = instanceOfDigestItemDto;
exports.DigestItemDtoFromJSON = DigestItemDtoFromJSON;
exports.DigestItemDtoFromJSONTyped = DigestItemDtoFromJSONTyped;
exports.DigestItemDtoToJSON = DigestItemDtoToJSON;
exports.DigestItemDtoToJSONTyped = DigestItemDtoToJSONTyped;
var DigestHighlightsGroupDto_1 = require("./DigestHighlightsGroupDto");
/**
 * Check if a given object implements the DigestItemDto interface.
 */
function instanceOfDigestItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('scores' in value) || value['scores'] === undefined)
        return false;
    if (!('matchDate' in value) || value['matchDate'] === undefined)
        return false;
    if (!('isFavourited' in value) || value['isFavourited'] === undefined)
        return false;
    if (!('highlights' in value) || value['highlights'] === undefined)
        return false;
    return true;
}
function DigestItemDtoFromJSON(json) {
    return DigestItemDtoFromJSONTyped(json, false);
}
function DigestItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'scores': json['scores'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'streamingPlatform': json['streamingPlatform'] == null ? undefined : json['streamingPlatform'],
        'matchDate': json['matchDate'],
        'isFavourited': json['isFavourited'],
        'highlights': (0, DigestHighlightsGroupDto_1.DigestHighlightsGroupDtoFromJSON)(json['highlights']),
    };
}
function DigestItemDtoToJSON(json) {
    return DigestItemDtoToJSONTyped(json, false);
}
function DigestItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'scores': value['scores'],
        'thumbnailUrl': value['thumbnailUrl'],
        'streamingPlatform': value['streamingPlatform'],
        'matchDate': value['matchDate'],
        'isFavourited': value['isFavourited'],
        'highlights': (0, DigestHighlightsGroupDto_1.DigestHighlightsGroupDtoToJSON)(value['highlights']),
    };
}
